import type { VatReportComponentProps } from './VatReportComponent';

export const VatReportComponent = {
    MountAsync: async (target: HTMLElement, props: VatReportComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { VatReportComponent } = await import('./VatReportComponent');
        return await mountReactComponentAsync(target, VatReportComponent, props);
    }
};
